// extracted by mini-css-extract-plugin
export var currencyInput = "_mt-1";
export var currencySymbol = "_mt-0";